import {
  Grid,
  makeStyles
} from '@material-ui/core';
import React from 'react';
import { useEffect } from 'react';
import { getUser } from '../redux/user';
import ActionPanel from './action-panel/ActionPanel';
import NavigationBar from './NavigationBar';
import Timecard from './timecard/TimeCard';
import Kpi from './action-panel/Kpi';
import MobileUx from './mobile/MobileUx';
import { useDispatch, useSelector } from 'react-redux';
import { getTimecard } from '../redux/timecard';
import Visible from '../components/Visible';
import ReceiptUpload from './ReceiptUpload.jsx';

const useStyles = makeStyles({
  root: {
    width: (isMac) => (isMac ? '100vw' : 'calc(100vw - 17px)'),
  },
  main: {
    width: (isMac) => (isMac ? '100vw' : 'calc(100vw - 17px)'),
  },
  timecard: {
    height: '100%',
    maxWidth: 'calc(100vw - 400px)',
  },
  actionpanel: {
    minWidth: '380px',
    marginTop: 64,
  },
});

const MainAuthenticated = () => {
  const dispatch = useDispatch();
  var isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  const currentTimecardId = useSelector((state) => state.user?.currentTimecardId);
  const timecardId = useSelector((state) => state.timecard?.timecardId);

  useEffect(() => {
    dispatch(getUser());
  }, []);
  useEffect(() => {
    if (currentTimecardId && !timecardId) {
      dispatch(getTimecard(currentTimecardId));
    }
  }, [currentTimecardId, timecardId]);

  const classes = useStyles(isMac);


  return (
    <>
      <Visible smDown>
        <MobileUx />
      </Visible>
      <Visible mdUp>
        <Grid
          container
          spacing={3}
          className={classes.root}
          id="post2-root"
        >
          <Grid item xs={12} id="post2-header">
            <NavigationBar />
          </Grid>
          <Grid container spacing={3} className={classes.main} id="post2-main">
            <Grid item xs={9} className={classes.timecard} id="post2-timecard">
              <Timecard />
            </Grid>
            <Grid item xs={3} className={classes.actionpanel} id="post2-action-panel2">
              <div
                style={{
                  position: 'fixed',
                  top: 80,
                  left: 'calc(100vw - 400px)',
                  width: 340,
                }}
              >
                <Kpi />
                <ActionPanel />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Visible>
      <ReceiptUpload />
    </>
  );
};

export default MainAuthenticated;
